export function isIdle(state) {
  return state.status === 'idle'
}
